import React from "react";
import { Mail, Building2 } from "lucide-react";
import { useI18n } from "@/i18n/I18nContext";
import Navbar from "@/components/layout/Navbar";
import Footer from "@/components/layout/Footer";
import SafeMailLink from "@/components/layout/SafeMailLink";
import SEO from "@/components/seo/SEO";

export default function Contact() {
  const { t } = useI18n();
  return (
    <div className="min-h-screen bg-background">
      <Navbar />
      <SEO title="Contact – Une question sur votre chanson personnalisée ? | Kalypso Music" description="Contactez l'équipe Kalypso Music : questions sur votre chanson personnalisée, votre commande ou la création musicale par IA. Réponse rapide." path="/contact" />
      <main className="mx-auto max-w-lg px-4 py-16 sm:px-6">
        <h1 className="font-heading text-2xl font-medium">{t("legalDocs.contactTitle")}</h1>
        <p className="mt-3 text-sm text-muted-foreground">{t("legalDocs.contactSubtitle")}</p>

        <div className="mt-8 rounded-2xl border border-border bg-card p-6">
          <div className="flex items-center gap-3">
            <Mail className="h-5 w-5 text-primary" />
            <div>
              <p className="text-xs text-muted-foreground">{t("legalDocs.contactEmailLabel")}</p>
              <SafeMailLink email="contactkalypsomusic@gmail.com" className="font-medium text-primary" />
            </div>
          </div>
          <div className="mt-5 flex items-center gap-3 border-t border-border pt-5">
            <Building2 className="h-5 w-5 text-primary" />
            <div>
              <p className="text-xs text-muted-foreground">{t("legalDocs.contactCompanyLabel")}</p>
              <p className="font-medium">Marc BARBIER (Entreprise Individuelle) - Kalypso Music</p>
              <p className="text-xs text-muted-foreground">SIREN 837 746 700 - France</p>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
